import { createPaneLayoutState } from './usePaneLayoutState';
import { createPaneLayoutResizer } from './usePaneLayoutResizer';

export const usePaneLayout = () => {
  let teardown = () => {};

  const initPaneLayout = () => {
    teardown();

    const container = document.querySelector('.main-container');
    if (!container) {
      return;
    }

    const sidebarHandle = container.querySelector(
      '[data-pane-resizer="sidebar"]'
    );
    const detailsHandle = container.querySelector(
      '[data-pane-resizer="details"]'
    );

    if (!sidebarHandle || !detailsHandle) {
      return;
    }

    const state = createPaneLayoutState({ container });
    const resizer = createPaneLayoutResizer({
      container,
      sidebarHandle,
      detailsHandle,
      state,
    });

    teardown = resizer.init();
  };

  const teardownPaneLayout = () => {
    teardown();
    teardown = () => {};
  };

  return {
    initPaneLayout,
    teardownPaneLayout,
  };
};
